import app from 'flarum/forum/app';

import config from '../common/config';
import setupHack from './setupHack';
import setupIndexPage from './setupIndexPage';
import setupBadgesPage from './setupBadgesPage';
import setupDiscussionHero from './setupDiscussionHero';
import setupDiscussionListItem from './setupDiscussionListItem';
import setupDiscussionPage from './setupDiscussionPage';
import setupGroupList from './setupGroupList';
import setupTagsPage from './setupTagsPage';
import setupUserCard from './setupUserCard';
import hackSetRoute from './hackSetRoute';

app.initializers.add(config.module.key, () => {
  hackSetRoute();
  setupIndexPage();
  setupHack();
  setupBadgesPage();
  setupDiscussionHero();
  setupDiscussionListItem();
  setupDiscussionPage();
  setupGroupList();
  setupTagsPage();
  setupUserCard();
});

// Expose compat API
import tagsCompat from './compat';
import { compat } from '@flarum/core/forum';

Object.assign(compat, tagsCompat);
